import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-380163b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Output", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "hint" }, [
  /*#__PURE__*/_createTextVNode(" Paste this line into your shell to test your prompt or append it to your "),
  /*#__PURE__*/_createElementVNode("code", null, "~/.bashrc"),
  /*#__PURE__*/_createTextVNode(" file to set it permanently. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_IconButton, {
      icon: "ClipboardIcon",
      title: "Copy command to clipboard",
      onClick: _ctx.copyToClipboard
    }, null, 8, ["onClick"]),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", {
      class: _normalizeClass(["ps1", { dark: _ctx.darkMode }])
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.ps1), 1)
    ], 2)
  ], 64))
}